import React from 'react';
import { CommentEnd, CommentStart } from '../comments';
import { useConfig } from '../config-context';
import { SectionItem } from '../section-item';
export function Group(props) {
    const { children, direction = 'ltr' } = props;
    const { renderComments } = useConfig();
    return (React.createElement(SectionItem, null,
        React.createElement("div", { className: "mj-outlook-group-fix", style: {
                fontSize: '0',
                lineHeight: '0',
                textAlign: 'left',
                display: 'inline-block',
                width: '100%',
                direction,
            } }, renderComments ? (React.createElement(React.Fragment, null,
            React.createElement(CommentStart, null),
            React.createElement("table", { border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation" },
                React.createElement("tr", null,
                    React.createElement(CommentEnd, null),
                    children,
                    React.createElement(CommentStart, null))),
            React.createElement(CommentEnd, null))) : (children))));
}
//# sourceMappingURL=group.js.map